import React from 'react'
import Layout from '../components/Layout'
import RichText from '../components/RichText'

export default function Home({
  heroTitle,
  heroSubtitle,
  heroImage,
  platformTitle,
  platformContent,
  platformImage,
  polosTitle,
  polosContent,
  polosImage
}) {
  return (
    <Layout fullWidth>
      {/* Hero Section */}
      <div
        className="min-h-screen bg-cover bg-center bg-no-repeat flex flex-col items-center justify-center text-white text-center px-4"
        style={{ backgroundImage: `url('${heroImage}')` }}
      >
        <div className="max-w-2xl">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 font-heading">
            {heroTitle}
          </h1>
          <h2 className="text-lg md:text-xl lg:text-2xl font-heading">
            {heroSubtitle}
          </h2>
        </div>
        <div className="mt-8">
          <a href="#verMais" className="text-white hover:text-brand-lighter transition-colors text-lg">
            &gt;&gt;Conheça!
          </a>
        </div>
      </div>

      {/* Esta Plataforma Section */}
      <div className="bg-brand-dark">
        <div className="flex flex-col md:flex-row">
          <div className="md:w-1/2">
            <img src={platformImage} alt="Plataforma" className="w-full h-full object-cover" />
          </div>
          <div className="md:w-1/2 p-6 md:p-8 lg:p-12 text-white">
            <h3 className="text-brand-lighter text-center text-2xl font-bold mb-6 font-heading">
              {platformTitle}
            </h3>
            <RichText content={platformContent} className="space-y-4 text-justify" invert />
          </div>
        </div>
      </div>

      {/* O que sao polos Section */}
      <div id="verMais" className="bg-brand-bg py-12">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row gap-8">
            <div className="md:w-1/2 text-justify">
              <h3 className="text-brand-dark text-2xl font-bold mb-4 font-heading">
                {polosTitle}
              </h3>
              <RichText content={polosContent} className="space-y-4" />
            </div>
            <div className="md:w-1/2">
              <img src={polosImage} alt="Polos Varejistas" className="w-full h-auto rounded" />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
